import React, {PropTypes} from 'react';

export default function EnumDisplayName({enumClass, value}) {
  return <span>{enumClass.displayName(value)}</span>;
}

EnumDisplayName.propTypes = {
  enumClass: PropTypes.func.isRequired,
  value: PropTypes.string.isRequired
};



// WEBPACK FOOTER //
// ./app/features/shared/components/EnumDisplayName.js